import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'taxtank-core/common';

@Injectable({
  providedIn: 'root'
})
export class AnonymGuard {
  private router = inject(Router);
  private jwtService = inject(JwtService);

  
  canActivate() {
    return this.check();
  }
  private check(): boolean {
    if (this.jwtService.getToken()) {
      this.router.navigateByUrl(this.jwtService.isClient() ? '/client' : '/firm');
    }
    return true;
  }
}
